import { CODIFICATION_ROLES } from "../constant/codification";

export interface RouteConfig {
  path: string;
  isProtected: boolean;
  requiredRoles?: string[];
}

const routes: RouteConfig[] = [
  {
    path: "/",
    isProtected: false,
  },
  {
    path: "/login",
    isProtected: false,
  },
  {
    path: "/register",
    isProtected: false,
  },
  {
    // Formulaire complet réservé aux organisations (écoles).
    path: "/register-organisation",
    isProtected: false,
  },
  {
    // Lien magique reçu par email : définition du mot de passe + activation.
    path: "/set-password",
    isProtected: false,
  },
  {
    path: "/callback/email-confirm",
    isProtected: false,
  },
  {
    path: "/reset-password",
    isProtected: false,
  },
  {
    path: "/dashboard",
    isProtected: true,
    requiredRoles: [CODIFICATION_ROLES.DASHBOARD],
  },
  {
    path: "/program",
    isProtected: true,
    requiredRoles: [CODIFICATION_ROLES.ACCESS_PROGRAM],
  },
  {
    path: "/student-projects",
    isProtected: true,
    requiredRoles: [CODIFICATION_ROLES.PROJECT_LIST],
  },
  {
    path: "/student-projects",
    isProtected: true,
    requiredRoles: [CODIFICATION_ROLES.PROJECT_LIST],
  },

  {
    path: "/tilmidai",
    isProtected: true,
    requiredRoles: [CODIFICATION_ROLES.ACCESS_TILMIDAI],
  },
  {
    path: "/projects",
    isProtected: true,
    requiredRoles: [CODIFICATION_ROLES.ACCESS_PROJECT],
  },
  {
    path: "/workflows",
    isProtected: true,
    requiredRoles: [CODIFICATION_ROLES.ACCESS_PROGRAM],
  },
  {
    path: "/workflow-steps",
    isProtected: true,
    requiredRoles: [CODIFICATION_ROLES.ACCESS_PROGRAM],
  },
  {
    path: "/project-details/:projectId",
    isProtected: true,
    requiredRoles: [CODIFICATION_ROLES.ACCESS_PROGRAM, CODIFICATION_ROLES.PROJECT_LIST],
  },
  {
    path: "/student-projects-store",
    isProtected: true,
    requiredRoles: [CODIFICATION_ROLES.SCHOOL_STORE],
  },
  {
    path: "/student-projects-tilmistore",
    isProtected: true,
    requiredRoles: [CODIFICATION_ROLES.TILMICODE_STORE],
  },
  {
    path: "/setup/media",
    isProtected: true,
    requiredRoles: [CODIFICATION_ROLES.ACCESS_PROGRAM],
  },
  {
    path: "/subject-courses/:subjectId",
    isProtected: true,
    requiredRoles: [CODIFICATION_ROLES.ACCESS_PROGRAM],
  },
  {
    path: "/course-details/:courseId",
    isProtected: true,
    requiredRoles: [CODIFICATION_ROLES.ACCESS_PROGRAM],
  },
  {
    path: "/course-progression/:lessonId",
    isProtected: true,
    requiredRoles: [CODIFICATION_ROLES.ACCESS_PROGRAM],
  },
  {
    path: "/conf/users",
    isProtected: true,
    requiredRoles: [CODIFICATION_ROLES.CONFIGURATION_OWN_USERS],
  },
  {
    path: "/conf/users/form",
    isProtected: true,
    requiredRoles: [CODIFICATION_ROLES.CONFIGURATION_OWN_USERS],
  },
  {
    path: "/paiement",
    isProtected: true,
    requiredRoles: [CODIFICATION_ROLES.PAIEMENT],
  },
  {
    // Retour du prestataire apres un paiement par carte. Meme role que l'ecran
    // de paiement : c'est la meme personne qui revient de sa banque.
    path: "/paiement/retour",
    isProtected: true,
    requiredRoles: [CODIFICATION_ROLES.PAIEMENT],
  },
  {
    path: "/paiement/pricing",
    isProtected: true,
    requiredRoles: [CODIFICATION_ROLES.PRICING],
  },
  {
    // Contrats ecoles : meme role que les tarifs publics, c'est la meme
    // responsabilite commerciale.
    path: "/paiement/pricing-b2b",
    isProtected: true,
    requiredRoles: [CODIFICATION_ROLES.PRICING],
  },
  {
    // Espace de l'animateur apporteur : rôle NOMINATIF (role_userapp). Le
    // serveur borne en plus l'écran à l'animateur de la session.
    path: "/apporteur",
    isProtected: true,
    requiredRoles: [CODIFICATION_ROLES.APPORTEUR],
  },
  {
    // Administration des animateurs : comptes (ADMIN_USERS), code et avantage
    // tarifaire (aussi PRICING). Le serveur garde chaque action.
    path: "/setup/apporteurs",
    isProtected: true,
    requiredRoles: [CODIFICATION_ROLES.ADMIN_USERS, CODIFICATION_ROLES.PRICING],
  },
  {
    // Rôles du contrat Monitoring v2 (§1) : MONITORING ou ADMIN_USERS.
    path: "/monitoring/students",
    isProtected: true,
    requiredRoles: [CODIFICATION_ROLES.MONITORING, CODIFICATION_ROLES.ADMIN_USERS],
  },
  {
    // MONITORING_FINANCE ou ADMIN_USERS.
    path: "/monitoring/finance",
    isProtected: true,
    requiredRoles: [CODIFICATION_ROLES.MONITORING_FINANCE, CODIFICATION_ROLES.ADMIN_USERS],
  },
  {
    // Tarifs des modèles IA : administrateurs uniquement (contrat §9).
    path: "/monitoring/ai-prices",
    isProtected: true,
    requiredRoles: [CODIFICATION_ROLES.ADMIN_USERS],
  },
  {
    path: "/setup/subject",
    isProtected: true,
    requiredRoles: [CODIFICATION_ROLES.COURSE_CONFIGURATOR],
  },
  {
    path: "/setup/lesson_project",
    isProtected: true,
    requiredRoles: [CODIFICATION_ROLES.COURSE_CONFIGURATOR],
  },
  {
    path: "/setup/course",
    isProtected: true,
    requiredRoles: [CODIFICATION_ROLES.COURSE_CONFIGURATOR],
  },
  {
    path: "/setup/chapter",
    isProtected: true,
    requiredRoles: [CODIFICATION_ROLES.COURSE_CONFIGURATOR],
  },
  {
    path: "/setup/epic",
    isProtected: true,
    requiredRoles: [CODIFICATION_ROLES.COURSE_CONFIGURATOR],
  },
  {
    path: "/setup/lesson",
    isProtected: true,
    requiredRoles: [CODIFICATION_ROLES.COURSE_CONFIGURATOR],
  },
  {
    path: "/setup/lesson-blockly-phaser",
    isProtected: true,
    requiredRoles: [CODIFICATION_ROLES.COURSE_CONFIGURATOR],
  },
  {
    path: "/setup/lesson-blockly-game",
    isProtected: true,
    requiredRoles: [CODIFICATION_ROLES.COURSE_CONFIGURATOR],
  },
  {
    path: "/setup/lesson-blockly-draw",
    isProtected: true,
    requiredRoles: [CODIFICATION_ROLES.COURSE_CONFIGURATOR],
  },
  {
    path: "/setup/lesson-blockly-arcade",
    isProtected: true,
    requiredRoles: [CODIFICATION_ROLES.COURSE_CONFIGURATOR],
  },
  {
    path: "/setup/lesson-slide",
    isProtected: true,
    requiredRoles: [CODIFICATION_ROLES.COURSE_CONFIGURATOR],
  },
  {
    path: "/setup/lesson-forms",
    isProtected: true,
    requiredRoles: [CODIFICATION_ROLES.COURSE_CONFIGURATOR],
  },
  {
    path: "/setup/lesson-h5p",
    isProtected: true,
    requiredRoles: [CODIFICATION_ROLES.COURSE_CONFIGURATOR],
  },
  {
    path: "/setup/lesson-ai-dataset",
    isProtected: true,
    requiredRoles: [CODIFICATION_ROLES.COURSE_CONFIGURATOR],
  },
  {
    path: "/setup/lesson-ai-model-builder",
    isProtected: true,
    requiredRoles: [CODIFICATION_ROLES.COURSE_CONFIGURATOR],
  },
  {
    path: "/setup/lesson-ai-play-ground",
    isProtected: true,
    requiredRoles: [CODIFICATION_ROLES.COURSE_CONFIGURATOR],
  },
  {
    path: "/setup/lesson-ai-prompting",
    isProtected: true,
    requiredRoles: [CODIFICATION_ROLES.COURSE_CONFIGURATOR],
  },
  {
    path: "/setup/lesson-puzzle",
    isProtected: true,
    requiredRoles: [CODIFICATION_ROLES.COURSE_CONFIGURATOR],
  },
  {
    path: "/setup/lesson-association",
    isProtected: true,
    requiredRoles: [CODIFICATION_ROLES.COURSE_CONFIGURATOR],
  },
  {
    path: "/setup/lesson-graphic-design",
    isProtected: true,
    requiredRoles: [CODIFICATION_ROLES.COURSE_CONFIGURATOR],
  },
  {
    path: "/setup/lesson-pscode",
    isProtected: true,
    requiredRoles: [CODIFICATION_ROLES.COURSE_CONFIGURATOR],
  },
  {
    path: "/setup/lesson-htmlcss",
    isProtected: true,
    requiredRoles: [CODIFICATION_ROLES.COURSE_CONFIGURATOR],
  },
  {
    path: "/setup/lesson-python",
    isProtected: true,
    requiredRoles: [CODIFICATION_ROLES.COURSE_CONFIGURATOR],
  },
  {
    path: "/setup/lesson-pythonphaser",
    isProtected: true,
    requiredRoles: [CODIFICATION_ROLES.COURSE_CONFIGURATOR],
  },
  {
    path: "/setup/lesson-console-js",
    isProtected: true,
    requiredRoles: [CODIFICATION_ROLES.COURSE_CONFIGURATOR],
  },
  {
    path: "/setup/lesson-console-py",
    isProtected: true,
    requiredRoles: [CODIFICATION_ROLES.COURSE_CONFIGURATOR],
  },
  {
    path: "/setup/signup-funnel",
    isProtected: true,
    requiredRoles: [CODIFICATION_ROLES.ADMIN_USERS],
  },
  {
    path: "/setup/users",
    isProtected: true,
    requiredRoles: [CODIFICATION_ROLES.ADMIN_USERS],
  },
  {
    path: "/setup/passwords",
    isProtected: true,
    requiredRoles: [CODIFICATION_ROLES.ADMIN_USERS],
  },
  {
    path: "/setup/blockly-objects",
    isProtected: true,
    requiredRoles: [CODIFICATION_ROLES.BLOCKLY_CONFIGURATOR],
  },
  {
    path: "/setup/sprites",
    isProtected: true,
    requiredRoles: [CODIFICATION_ROLES.BLOCKLY_CONFIGURATOR],
  },
  {
    path: "/setup/sprites/edit",
    isProtected: true,
    requiredRoles: [CODIFICATION_ROLES.BLOCKLY_CONFIGURATOR],
  },
  {
    path: "/setup/advert",
    isProtected: true,
    requiredRoles: [CODIFICATION_ROLES.ADMIN_ADVERT],
  },
  {
    path: "/setup/roles",
    isProtected: true,
    requiredRoles: [CODIFICATION_ROLES.ROLE_CONFIGURATOR],
  },
  {
    path: "/setup/translations",
    isProtected: true,
    requiredRoles: [CODIFICATION_ROLES.TRANSLATION_MANAGER],
  },
  {
    path: "/td",
    isProtected: true,
    requiredRoles: [CODIFICATION_ROLES.DEVELOPER],
  },
  {
    path: "/rd",
    isProtected: true,
    requiredRoles: [CODIFICATION_ROLES.ADMIN_ADVERT],
  },
  {
    path: "/access-denied",
    isProtected: false,
  },
];

export default routes;
